import React, { useEffect } from "react";
import { connect } from "react-redux";
import { RootState } from "../redux/root-store";
import { useLocation, useNavigate } from "react-router-dom";
import { shareContact } from "../firebase";

function useQuery() {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
}

const mapStateToProps = (state: RootState) => ({
    loggedUser: state.session.user,
});

interface Props extends ReturnType<typeof mapStateToProps> {}

const AcceptSharedContact = (props: Props) => {
    const query = useQuery();
    const navigate = useNavigate();
    const contactId = query.get("contactId");

    const acceptSharedContact = async (userId: string, contactId: string) => {
        await shareContact(userId, contactId);
        navigate("/contacts");
    };

    useEffect(() => {
        if (!contactId) return;
        if (!props.loggedUser) return;
        acceptSharedContact(props.loggedUser.user_id, contactId);
    }, [contactId]);

    return null;
};

export default connect(mapStateToProps, {})(AcceptSharedContact);
